<template>
    <transition name="modal" >
        <div class="modal-mask" @click="$emit('close')">
            <div class="modal-wrapper scrollable">
                <div class="modal-container modal-dialog" @click.stop>
                    <button type="button" class="close close-corner" @click="$emit('close')"><span aria-hidden="true">&times;</span></button>
                    <div class="modal-header">
                        <slot name="header">
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import $ from 'jquery'
    export default {
        data() {
            return {
            }
        },
        mounted: function () {  
            let vm = this
            document.addEventListener("keydown", (e) => {
                if (e.keyCode == 27) {
                    vm.$emit('close')
                }
            });
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>